export default __webpack_public_path__ + "static/media/plattform_highlight_blur.acbb6004.png";